import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.value = window.location.pathname + window.location.search
  }
}
